<template>
    <div>
        <div class="content">
            <a href="/">
                <img
                    :src="`${$scope.CDN_IMAGES}/images/site/novo_layout_chico/logo-chico.png?auto=compress,format&q=65`"
                />
            </a>
            <img
                class="ml-7 hidden-xs-down"
                :src="`${$scope.CDN_IMAGES}/images/site/novo_layout_chico/chicundum.png?auto=compress,format&q=65`"
            />
        </div>
        <div class="content hidden-xs-up mt-3 mb-4">
            <img
                class="mt-3 hidden-xs-up"
                :src="`${$scope.CDN_IMAGES}/images/site/novo_layout_chico/chicundum.png?auto=compress,format&q=65`"
            />
        </div>
        <div class="content">
            <p class="ml-8 hidden-xs-down text-top">
                {{ textTop }}
                <strong>{{ textTopBold }}</strong>
            </p>
            <p class="hidden-xs-up text-top">
                {{ textTop }}<br />
                <strong>{{ textTopBold }}</strong>
            </p>
        </div>

        <div class="content mt-4">
            <div
                v-for="(artist, index) in artists.slice().reverse()"
                :key="index"
                class="mt-4 col-xs-12 col-sm-6 col-md-2 col-lg-4"
            >
                <a class="text-movies frame" @click="toggleInfo(artists.length - 1 - index)">{{
                    artist.name
                }}</a>
            </div>
        </div>
        <div class="content mt-4">
            <hr />
        </div>
        <div v-if="selectedArtist" id="artistsAnchor">
            <div class="content" :key="selectedArtist.id">
                <div class="content">
                    <h4 class="text-movies mb-5" style="font-size: 150%">
                        {{ selectedArtist.name }}
                    </h4>
                    <div class="ml-5 hidden-xs-down">
                        <iframe
                            width="95%"
                            height="500"
                            :src="selectedArtist.link"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div class="hidden-xs-up mb-5">
                        <iframe
                            width="100%"
                            height="200"
                            :src="selectedArtist.link"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen
                        ></iframe>
                    </div>
                    <div v-if="selectedArtist.images" class="container-carousel hidden-xs-down">
                        <div class="carousel">
                            <div class="images-container">
                                <div class="image">
                                    <button class="scrollbar-button-left" @click="prevImage()">
                                        <i
                                            class="icon-cr icon-arrow-right"
                                            style="transform: rotate(180deg)"
                                        ></i>
                                    </button>
                                    <img :src="currentImage.img" :key="currentImage.key" />
                                </div>
                                <div class="image">
                                    <img :src="nextImage.img" :key="nextImage.key" />
                                    <button
                                        class="scrollbar-button-right hidden-touch"
                                        @click="nextImg()"
                                    >
                                        <i class="icon-cr icon-arrow-right"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="selectedArtist.images" class="carousel-mobile hidden-xs-up">
                        <div class="images-container-mobile">
                            <div class="image-mobile">
                                <img :src="currentImage.img" :key="currentImage.key" />
                            </div>
                        </div>
                        <button class="prev scrollbar-button-left" @click="prevImage()">
                            <i
                                class="icon-cr icon-arrow-right"
                                style="transform: rotate(180deg)"
                            ></i>
                        </button>
                        <button class="next scrollbar-button-right" @click="nextImg()">
                            <i class="icon-cr icon-arrow-right"></i>
                        </button>
                    </div>
                    <div class="content hidden-xs-down ml-8 mt-4 mb-4">
                        <div class="secoes mb-5">
                            <div class="titulo-secoes mb-5">
                                <h4>FAIXAS</h4>
                            </div>
                            <div class="mt-5" style="width: 100%">
                                <p
                                    class="text-secoes"
                                    v-for="(track, index) in selectedArtist.tracks"
                                    :key="index"
                                >
                                    {{ track }}
                                </p>
                            </div>
                        </div>
                        <div class="secoes mb-5">
                            <div class="titulo-secoes mb-5">
                                <h4>ARTISTAS</h4>
                            </div>
                            <div class="mt-5" style="width: 100%">
                                <p
                                    class="text-secoes"
                                    v-for="(guest, index) in selectedArtist.guests"
                                    :key="index"
                                >
                                    {{ guest }}
                                </p>
                            </div>
                        </div>
                        <div v-if="selectedArtist.participations" class="secoes mb-5">
                            <div class="titulo-secoes mb-5">
                                <h4>PARTICIPAÇÕES ESPECIAIS</h4>
                            </div>
                            <div class="mt-5" style="width: 100%">
                                <p
                                    class="text-secoes"
                                    v-for="(participation, index) in selectedArtist.participations"
                                    :key="index"
                                >
                                    {{ participation }}
                                </p>
                            </div>
                        </div>
                        <div class="secoes mb-5">
                            <div class="titulo-secoes mb-5">
                                <h4>CRÉDITOS</h4>
                            </div>
                            <div class="mt-5" style="width: 100%">
                                <p
                                    class="text-secoes"
                                    v-for="(credit, index) in selectedArtist.credits"
                                    :key="index"
                                >
                                    {{ credit }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="content hidden-xs-up mt-5">
                        <div class="titulo-secoes text-bold">
                            <h4><strong>FAIXAS</strong></h4>
                        </div>
                        <hr />
                        <div class="mt" style="width: 100%">
                            <p
                                class="text-secoes"
                                v-for="(track, index) in selectedArtist.tracks"
                                :key="index"
                            >
                                {{ track }}
                            </p>
                        </div>
                        <div class="titulo-secoes mt-4 text-bold">
                            <h4><strong>ARTISTAS</strong></h4>
                        </div>
                        <hr />
                        <div class="mt" style="width: 100%">
                            <p
                                class="text-secoes"
                                v-for="(guest, index) in selectedArtist.guests"
                                :key="index"
                            >
                                {{ guest }}
                            </p>
                        </div>
                        <div
                            v-if="selectedArtist.participations"
                            class="titulo-secoes mt-4 text-bold"
                        >
                            <h4><strong>PARTICIPAÇÕES ESPECIAIS</strong></h4>
                        </div>
                        <hr />
                        <div class="mt" style="width: 100%">
                            <p
                                class="text-secoes"
                                v-for="(participation, index) in selectedArtist.participations"
                                :key="index"
                            >
                                {{ participation }}
                            </p>
                        </div>
                        <div class="titulo-secoes mt-4 text-bold">
                            <h4><strong>CRÉDITOS</strong></h4>
                        </div>
                        <hr />
                        <div class="mt" style="width: 100%">
                            <p
                                class="text-secoes"
                                v-for="(credit, index) in selectedArtist.credits"
                                :key="index"
                            >
                                {{ credit }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import cr$ from '../../../common/crquery';

    export default {
        name: 'Chicundum',

        data() {
            return {
                textTop:
                    'A Chico Rei vem se transformando, também, em uma marca musical. Tivemos a honra de conhecer e virar\n' +
                    'parceiros de uma turma\n' +
                    'gigante, indescritível - que agora tem coleção com a gente! E por que, além de camisetas, não levar\n' +
                    'música para o mundo? Fazer\n' +
                    'som autoral de qualidade chegar a mais e mais ouvidos.',
                textTopBold:
                    'Bora conhecer uma galera boa? Aumente o som e navegue pelos artistas abaixo.',
                selectedArtistIndex: 0,
                currentImageIndex: 0,
                artists: [
                    {
                        id: 9,
                        name: '#10. MUXIMA',
                        link: 'https://www.youtube.com/embed/BcAapogDkG4',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/muxima/muxima-1.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/muxima/muxima-chicundum-3.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/muxima/show-juiz-de-fora-4.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/muxima/beco-juiz-de-fora-5.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/muxima/camisetas-musica-6.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/muxima/juiz-de-fora-7.png?auto=compress,format&q=65',
                        ],
                        tracks: ['Mete Dança', 'Foda-se', 'Posto 9', 'Esse Balanço'],
                        guests: [
                            'Muxima: voz',
                            'Moraez: violão e voz',
                            'Arthur Nader: DJ e tune engineer',
                            'RT Mallone: voz',
                        ],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de fotografia: Thiago Britto',
                            'Identidade visual: Ana Gouveia, Mariana Beck, Pedro Costa e Rayellen Lima',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Victor Rezende',
                            'Figurino: Laise Lutz e Marcela Vasconcelos',
                            'Maquiagem: Lucas Melo',
                            'Captação de áudio e Mixagem de som: Kasron Rodrigues',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Agradecimentos a Centro Cultural Beco, Marv Curadoria, Dangê ua Lunda e Manchester Locadora',
                        ],
                    },
                    {
                        id: 8,
                        name: '#9. Laura Jannuzzi',
                        link: 'https://www.youtube.com/embed/OcpJ4BgjQKU',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura-jannuzzi/chicundum_01.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura-jannuzzi/chicundum_02.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura-jannuzzi/chicundum_03.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura-jannuzzi/chicundum_04.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura-jannuzzi/chicundum_05.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura-jannuzzi/chicundum_06.png?auto=compress,format&q=65',
                        ],
                        tracks: ['Sede Da Manhã', 'Sete Luas', 'Vulcão e Cometa', 'Temporal'],
                        guests: [
                            'Laura Jannuzzi: voz',
                            'Pedro Brum: guitarra',
                            'Luiz Henrique: piano',
                        ],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de fotografia: Thiago Britto',
                            'Identidade visual: Ana Gouveia, Mariana Beck, Pedro Costa e Rayellen Lima',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Victor Rezende',
                            'Figurino: Laise Lutz',
                            'Maquiagem: Lucas Melo',
                            'Captação de áudio e Mixagem de som: Kasron Rodrigues',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Agradecimentos a Manchester Locadora e Centro Cultural Beco',
                        ],
                    },
                    {
                        id: 7,
                        name: '#8. Obey',
                        link: 'https://www.youtube.com/embed/G-9TB3eEwhE',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/obey/1.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/obey/2.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/obey/3.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/obey/4.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/obey/5.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/obey/6.png?auto=compress,format&q=65',
                        ],
                        tracks: ['Dança', 'Assim que vai ser', 'Somos Dois'],
                        guests: [
                            'Douglas Rodrigues: guitarra e voz',
                            'Filipe Tedeschi: bateria',
                            'Igor Santos: voz',
                            'Iuri Mourão: baixo e voz',
                            'Marcel Magalhães: guitarra',
                        ],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de fotografia: Thiago Britto',
                            'Identidade visual: Ana Gouveia, Mariana Beck, Pedro Costa e Rayellen Lima',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Victor Rezende',
                            'Figurino: Letícia Bara e Lucas Melo',
                            'Maquiagem: Lucas Melo',
                            'Captação de áudio e Mixagem de som: Kasron Rodrigues',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Agradecimentos a Manchester Locadora e Centro Cultural Beco',
                        ],
                    },
                    {
                        id: 6,
                        name: '#7. Varanda',
                        link: 'https://www.youtube.com/embed/LAOE6RmqPv4',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/varanda/1.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/varanda/2.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/varanda/3.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/varanda/4.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/varanda/5.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/varanda/6.png?auto=compress,format&q=65',
                        ],
                        tracks: ['Leva e Vem', 'Gostei', 'Depois'],
                        guests: [
                            'Amélia do Carmo: voz',
                            'Augusto Vargas: baixo e voz',
                            'Bernardo Merhy: bateria',
                            'Mario Lorenzi: guitarra',
                        ],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de fotografia: Thiago Britto',
                            'Identidade visual: Ana Gouveia, Mariana Beck, Pedro Costa e Rayellen Lima',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Leandro Mockdece',
                            'Figurino: Letícia Bara',
                            'Maquiagem: Grazi Macário',
                            'Captação de áudio e Mixagem de som: Kasron Rodrigues',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Agradecimentos a Manchester Locadora e Centro Cultural Beco',
                        ],
                    },
                    {
                        id: 5,
                        name: '#6. ALESSANDRA CRISPIM',
                        link: 'https://www.youtube.com/embed/m3gDDoTT4oQ',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/alessandra/1.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/alessandra/2.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/alessandra/3.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/alessandra/4.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/alessandra/5.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/alessandra/6.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/alessandra/7.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/alessandra/8.png?auto=compress,format&q=65',
                        ],
                        tracks: [
                            'O peso da pele',
                            'Posição de risco',
                            'Filho de Oxossi',
                            'Laranjeira',
                        ],
                        guests: [
                            'Alessandra Crispin: voz, direção musical',
                            'João Paulo Lanini: guitarra, violão, codireção musical',
                            'Tiago Lazzarini: baixo, regência (beats)',
                            'Mari Assis: percussão (timbal, agogô, caxixi, caixa de folia, efeitos)',
                            'Almin Bah: percussão (congas, pad eletônico, efeitos)',
                        ],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de fotografia: Thiago Britto',
                            'Identidade visual: Ana Gouveia, Mariana Beck, Pedro Costa e Rayellen Lima',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Leandro Mockdece',
                            'Figurino: Letícia Bara',
                            'Maquiagem: Grazi Macário',
                            'Captação de áudio e Mixagem de som: Kasron Rodrigues',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Agradecimentos a Manchester Locadora e Centro Cultural Beco',
                        ],
                    },
                    {
                        id: 4,
                        name: '#5. ROÇA NOVA',
                        link: 'https://www.youtube.com/embed/uUL2GuJVuzQ',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/roca-nova/1.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/roca-nova/2.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/roca-nova/3.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/roca-nova/4.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/roca-nova/5.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/roca-nova/6.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/roca-nova/7.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/roca-nova/1.png?auto=compress,format&q=65',
                        ],
                        tracks: [
                            'Alma de Gato',
                            'Canto de Rudá',
                            'Quebra Coco',
                            'Conversa Pra Boi Dormir',
                        ],
                        guests: [
                            'Pedro Tasca: Voz e Violão',
                            'João Manga: Bateria e Voz',
                            'Hector Eiterer: Baixo',
                            'Marco Maia: Guitarra',
                            'Bernardo Leitão: Percussão',
                            'Tiago Croce: Viola e Guitarra',
                            'Thalles Oliveira: Percussão',
                        ],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de fotografia: Thiago Britto',
                            'Identidade visual: Ana Gouveia, Mariana Beck, Pedro Costa e Rayellen Lima',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Leandro Mockdece',
                            'Cor: Leandro Mockdece',
                            'Figurino: Letícia Bara',
                            'Maquiagem: Lizandra Braga',
                            'Iluminação: Vinicius Ildefonso',
                            'Captação de áudio e Mixagem de som: Kasron Rodrigues',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Agradecimentos a Manchester Locadora, Isadora Mayrinck e Centro Cultural Beco',
                        ],
                    },
                    {
                        id: 3,
                        name: '#4. HELGI',
                        link: 'https://www.youtube.com/embed/RABr2IjUejA',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/Helgi/1.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/Helgi/2.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/Helgi/3.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/Helgi/4.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/Helgi/5.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/Helgi/6.png?auto=compress,format&q=65',
                        ],
                        tracks: [
                            'Refazer',
                            'Onde nascem os sonhos',
                            'Guadalupe',
                            'Queda livre',
                            'Monólogo',
                        ],
                        guests: ['Helgi: cantor e compositor'],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de arte: Nino de Barros',
                            'Direção de fotografia: Thiago Britto',
                            'Identidade visual: Ana Gouveia, Mariana Beck, Pedro Costa e Rayellen Lima',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Leandro Mockdece',
                            'Figurino: Nino de Barros e Letícia Bara',
                            'Maquiagem: Renata Falci',
                            'Captação de áudio e Mixagem de som: Adega Estúdio por Giovanni Finck',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Agradecimentos a Elemento Casa, Manchester Locadora, Isadora Mayrinck e Bernardo Traad',
                        ],
                    },
                    {
                        id: 2,
                        name: '#3. RT MALLONE',
                        link: 'https://www.youtube.com/embed/C_O6HuVaRFk',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/rt/1.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/rt/2.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/rt/3.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/rt/4.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/rt/5.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/rt/6.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/rt/7.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/rt/8.png?auto=compress,format&q=65',
                        ],
                        tracks: [
                            '100 Balas',
                            'Não Vai Voltar',
                            'Sinestesia',
                            'Monalisa',
                            'Tempo de Deus',
                            'Fod * Se o Rap',
                        ],
                        guests: [
                            'RT Mallone: principal',
                            'BRK Mallone: participação e dobra',
                            'Fabin: DJ',
                        ],
                        participations: [
                            'Aka Fraze : voz',
                            'Villela : guitarra',
                            'Marcelo Castro : baixo',
                            'Jack Sampedro : sax',
                        ],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de arte: Nino de Barros',
                            'Direção de fotografia: Thiago Britto',
                            'Identidade visual: Ana Gouveia, Mariana Beck, Pedro Costa e Rayellen Lima',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Leandro Mockdece',
                            'Técnico de Luz: Vinícius Ildefonso',
                            'Figurino: Nino de Barros e Letícia Bara',
                            'Maquiagem: Renata Falci',
                            'Captação de áudio e Mixagem de som: Adega Estúdio por Giovanni Finck',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Agradecimentos a Filipe Lima / Lima design, Manchester Locadora e Bernardo Traad',
                        ],
                    },
                    {
                        id: 1,
                        name: '#2. TATA CHAMA E AS INFLAMÁVEIS',
                        link: 'https://www.youtube.com/embed/zC2Q32PJdao',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/tata-chama/1.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/tata-chama/2.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/tata-chama/3.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/tata-chama/4.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/tata-chama/5.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/tata-chama/6.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/tata-chama/7.png?auto=compress,format&q=65',
                        ],
                        tracks: ['Tierra y Libertad', 'Reza de Amor', 'Morte e Vida'],
                        guests: [
                            'Tata Rocha: vocal e teclado',
                            'Eduardo Yroxe: percussão',
                            'Sarah Vieira: vocal e flauta',
                            'Alice Santiago: vocal e violão',
                            'Bruno Targs: percussão',
                            'Pedro Brum: guitarra',
                            'Daniela Zorzal: baixo',
                        ],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de arte: Nino de Barros',
                            'Direção de fotografia: Thiago Britto',
                            'Co - produção: Carlos Fernando Cunha',
                            'Identidade visual: Ana Gouveia, Pedro Costa e Rayellen Lima',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Leandro Mockdece',
                            'Figurino: Nino de Barros e Letícia Bara',
                            'Maquiagem: Renata Falci',
                            'Captação de áudio: Adega Estúdio por Giovanni Finck',
                            'Mixagem de som: Pedro Brum',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Produção Executiva da banda: Maria Elisa Duarte',
                            'Acessórios: Lívia Almeida',
                            'Técnico da banda: Felipe Vieira',
                            'Agradecimentos a Studio Ambientar, Filipe Lima / Lima design, Elemento Casa, Manchester',
                            'Locadora e Bernardo Traad',
                        ],
                    },
                    {
                        id: 0,
                        name: '#1. LAURA CONCEIÇÃO',
                        link: 'https://www.youtube.com/embed/mVQCLhSQqU8',
                        images: [
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura/1.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura/2.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura/3.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura/4.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura/5.png?auto=compress,format&q=65',
                            'https://chico-rei.imgix.net/images/hotsites/chicundum/projeto/laura/6.png?auto=compress,format&q=65',
                        ],
                        tracks: [
                            'Grão de Areia',
                            'Hoje o sol não apareceu',
                            'Caos',
                            'Sossego',
                            'Espelho',
                        ],
                        guests: [
                            'Laura Conceição: voz e guitarra',
                            'Amanda FIE: disc jockeying e voz',
                        ],
                        credits: [
                            'Direção, produção e montagem: Marcos Pianta',
                            'Direção de arte: Nino de Barros',
                            'Direção de fotografia: Thiago Britto',
                            'Co - produção: Carlos Fernando Cunha',
                            'Identidade visual: Ana Gouveia e Pedro Costa',
                            'Câmeras: Marcos Pianta, Raul Gonçalves e Leandro Mockdece',
                            'Figurino: Nino de Barros e Letícia Bara',
                            'Maquiagem: Renata Falci',
                            'Assistente: Guilherme Perobelli',
                            'Captação de áudio: Renato Dias',
                            'Mixagem de som: Maurício Ávila',
                            'Idealização: Vítor Bara e Vitor Vizeu',
                            'Agradecimentos: Estúdio Sensorial',
                        ],
                    },
                ],
            };
        },

        computed: {
            selectedArtist() {
                return this.artists[this.selectedArtistIndex];
            },

            currentImage() {
                if (!this.selectedArtist.images || !this.selectedArtist.images.length) return null;

                return {
                    img: this.selectedArtist.images[this.currentImageIndex],
                    key: `${this.selectedArtist.id}${this.currentImageIndex}`,
                };
            },

            nextImage() {
                if (!this.selectedArtist.images || !this.selectedArtist.images.length) return null;

                const nextIndex = (this.currentImageIndex + 1) % this.selectedArtist.images.length;

                return {
                    img: this.selectedArtist.images[nextIndex],
                    key: `${this.selectedArtist.id}${nextIndex}`,
                };
            },
        },

        methods: {
            toggleInfo(index) {
                this.selectedArtistIndex = index;
                this.currentImageIndex = 0;
                cr$.byId('artistsAnchor').scrollIntoView();
            },

            prevImage() {
                if (this.currentImageIndex === 0) {
                    this.currentImageIndex = this.selectedArtist.images.length - 1;
                } else {
                    this.currentImageIndex -= 1;
                }
            },
            nextImg() {
                this.currentImageIndex =
                    (this.currentImageIndex + 1) % this.selectedArtist.images.length;
            },
        },
    };
</script>
